/**
 * Custom Theme JavaScript
 * Extracted from theme.liquid for better maintainability, caching, and performance
 * 
 * This file contains:
 * - Page reload logic for bfcache handling
 * - Country detection and display
 * - Bundle variant selection
 * - Menu and cart drawer click-outside handlers
 */

(function () {
    'use strict';

    /**
     * ========================================
     * Page Navigation/Reload Handling
     * Handles back-forward cache (bfcache) to ensure fresh page state
     * ========================================
     */
    function initPageReloadHandling() {
        // Check if navigation was via back/forward
        if (window.performance) {
            const navEntries = window.performance.getEntriesByType('navigation');
            if ((navEntries.length && navEntries[0].type === 'back_forward') ||
                (window.performance.navigation && window.performance.navigation.type === 2)) {
                window.location.reload();
            }
        }

        // Handle pageshow event for bfcache
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {

                // iOS Safari restores the full DOM from bfcache, which means any open
                // menu drawer will briefly flash open before the page reloads.
                // Immediately hide the menu and strip all open state synchronously
                // so there is zero visible flash before the reload fires.
                try {
                    // Force-close the menu drawer details element
                    var menuDetails = document.getElementById('Details-menu-drawer-container');
                    if (menuDetails) {
                        menuDetails.removeAttribute('open');
                        menuDetails.classList.remove('menu-opening');
                    }
                    // Remove all submenu open states
                    document.querySelectorAll('details[open]').forEach(function (el) {
                        el.removeAttribute('open');
                        el.classList.remove('menu-opening');
                    });
                    document.querySelectorAll('.submenu-open').forEach(function (el) {
                        el.classList.remove('submenu-open');
                    });
                    // Remove body classes added by openMenuDrawer
                    document.body.classList.remove(
                        'menu-drawer-open',
                        'overflow-hidden-tablet',
                        'overflow-hidden-desktop'
                    );
                    // Hide the drawer panel itself immediately via inline style
                    // so it doesn't render during the brief time before reload
                    var menuDrawer = document.getElementById('menu-drawer');
                    if (menuDrawer) {
                        menuDrawer.style.visibility = 'hidden';
                        menuDrawer.style.transform = 'translateX(-100%)';
                    }
                } catch (e) {
                    // Silently ignore — reload below will correct any state
                }

                window.location.reload();
            }
        });
    }

    /**
     * ========================================
     * Country Detection and Display
     * Fetches visitor's country and updates all country display elements
     * ========================================
     */
    async function fetchDatacart() {
        try {
            let fetchUrl;
            if (Shopify.routes && Shopify.routes.root) {
                fetchUrl = Shopify.routes.root + 'browsing_context_suggestions.json';
            } else {
                fetchUrl = '/browsing_context_suggestions.json';
            }

            const response = await fetch(fetchUrl);
            const jsonResponse = await response.json();

            if (jsonResponse && jsonResponse.detected_values && jsonResponse.detected_values.country && jsonResponse.detected_values.country.handle) {
                window.countryCode = jsonResponse.detected_values.country.handle;
                console.log(`${window.countryCode}`, 'code code');

                // Update text content for country code elements
                const countryElements = [
                    '[data-product-country-bar]',
                    '[data-product-country-code]',
                    '[data-product-country-code-collaps]',
                    '[data-product-country-code-des]'
                ];

                countryElements.forEach(function (selector) {
                    const el = document.querySelector(selector);
                    if (el) {
                        el.innerHTML = window.countryCode;
                    }
                });

                // Update SVG Flag
                const flagImg = document.querySelector('[data-product-free-shipping-flag]');
                if (flagImg) {
                    flagImg.src = 'https://flagcdn.com/' + window.countryCode.toLowerCase() + '.svg';
                }
            }
        } catch (error) {
            console.error('Error fetching country data:', error);
        }
    }

    /**
     * ========================================
     * Bundle Variant Selection
     * Handles variant selection for bundle products
     * ========================================
     */
    function initializeVariantSelection() {
        document.querySelectorAll('.collection-swatch-input').forEach(function (input) {
            input.addEventListener('change', function (event) {
                const target = event.target;
                const form = target.closest('#variant-selects-bundle-products');
                const selectedFieldset = target.closest('fieldset');

                if (!selectedFieldset) return;

                const selectedPos = selectedFieldset.getAttribute('data-pos');
                if (!selectedPos) return;

                let variantId = null;
                let variantPrice = 0;
                let variantTitle = '';

                if (target.classList.contains('custom-product-input')) {
                    variantId = target.value;
                    variantTitle = target.dataset.title || '';
                    variantPrice = parseFloat(target.dataset.inputPrice) || 0;
                } else {
                    if (!form) return;
                    const jsonElement = form.querySelector('[type="application/json"]');
                    if (!jsonElement) return;

                    const fieldsets = Array.from(form.querySelectorAll('fieldset'));
                    const options = fieldsets.map(function (f) {
                        const checked = f.querySelector("input[type='radio']:checked");
                        return checked ? checked.value : null;
                    });

                    try {
                        const allVariants = JSON.parse(jsonElement.textContent);
                        const currentVariant = allVariants.find(function (variant) {
                            return variant.options.every(function (opt, i) {
                                return opt === options[i];
                            });
                        });

                        if (!currentVariant) return;
                        console.log(currentVariant, 'currentVariant');

                        variantId = currentVariant.id;
                        variantTitle = currentVariant.title;
                        variantPrice = parseFloat(currentVariant.price) || 0;
                    } catch (err) {
                        return;
                    }
                }

                const inputToUpdate = document.querySelector(
                    '.input_bundle .input_var_id[data-pos="' + selectedPos + '"]'
                );
                console.log(selectedPos, 'selectedPos');
                console.log(inputToUpdate, 'inputToUpdate');

                if (inputToUpdate && variantId != null) {
                    inputToUpdate.value = variantId;
                    inputToUpdate.setAttribute('data-price', variantPrice);

                    const label = document.querySelector('label[for="' + inputToUpdate.id + '"]');
                    if (label) {
                        const titleEl = label.querySelector('.bundle_var_title');
                        if (titleEl) {
                            titleEl.innerText = variantTitle;
                        }
                    }
                }

                updateTotalPrice();
            });
        });

        updateTotalPrice();
    }

    /**
     * Updates the total price display for bundle products
     */
    function updateTotalPrice() {
        const inputs = document.querySelectorAll('.input_bundle .input_var_id');
        let total = 0;

        inputs.forEach(function (input) {
            total += parseFloat(input.getAttribute('data-price')) || 0;
        });

        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.Money_Filter) {
            const formatted = Shopify.formatMoney(total, window.Money_Filter);
            const targetEl = document.querySelector('.total_append');
            if (targetEl) {
                targetEl.textContent = formatted;
            }
        }
    }

    /**
     * Adds all bundle items to cart
     */
    function addBundleToCart() {
        const inputs = document.querySelectorAll('.input_var_id');
        const itemsToAdd = [];

        inputs.forEach(function (input) {
            const variantId = input.value;
            if (variantId) {
                itemsToAdd.push({
                    id: variantId,
                    quantity: 1
                });
            }
        });

        if (itemsToAdd.length === 0) {
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: itemsToAdd })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                window.location.href = '/cart';
            })
            .catch(function (err) {
                console.error('Cart add error:', err);
                alert('Something went wrong. Try again.');
            });
    }

    // Expose addBundleToCart globally for onclick handlers
    window.addBundleToCart = addBundleToCart;

    // Expose initializeVariantSelection globally - called from global.js after dynamic content load
    window.initializeVariantSelection = initializeVariantSelection;

    /**
     * ========================================
     * Menu Drawer Click Outside Handler
     * Closes the menu drawer when clicking outside of it
     * ========================================
     */
    function initMenuDrawerClickOutside() {
        document.addEventListener('click', function (event) {
            const menuDrawer = document.querySelector('header-drawer details');
            const summary = menuDrawer ? menuDrawer.querySelector('summary') : null;

            // If menuDrawer doesn't exist, exit
            if (!menuDrawer) return;

            // Check if the click happened outside the header-drawer
            const clickedOutside = !menuDrawer.contains(event.target);

            if (clickedOutside && menuDrawer.hasAttribute('open')) {
                // Remove the 'open' attribute and class
                menuDrawer.removeAttribute('open');
                menuDrawer.classList.remove('menu-opening');

                // Set aria-expanded to false
                if (summary) {
                    summary.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    /**
     * ========================================
     * Cart Drawer Click Outside Handler
     * Closes the cart drawer when clicking outside of it
     * ========================================
     */
    function initCartDrawerClickOutside() {
        document.addEventListener('click', function (event) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer) return;

            const clickedOutside = !cartDrawer.contains(event.target);
            // Check if the drawer is open (Shopify adds "is-open" class)
            const isOpen = cartDrawer.classList.contains('is-open');

            if (clickedOutside && isOpen) {
                cartDrawer.classList.remove('is-open');
                cartDrawer.removeAttribute('open');
                // Optionally, update aria attributes if your button uses one
                const toggleButton = document.querySelector('[aria-controls="CartDrawer"]');
                if (toggleButton) {
                    toggleButton.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    /**
     * ========================================
     * Cart Drawer Subtotal Handler
     * Handles removing 'active' class when subtotal is 0
     * ========================================
     */
    function initCartDrawerSubtotalHandler() {
        document.addEventListener('click', function (event) {
            const cartDrawer = document.querySelector('cart-drawer.drawer');
            if (!cartDrawer) return;

            // Subtotal element — adjust selector as per your theme
            const subtotalEl = cartDrawer.querySelector('.totals__total-value, .cart-subtotal, [data-cart-subtotal]');
            let subtotal = 0;

            if (subtotalEl) {
                subtotal = parseFloat(subtotalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
            }

            const clickedOutside = !cartDrawer.contains(event.target);

            // Remove 'active' if subtotal = 0 and clicked outside
            if (clickedOutside && subtotal === 0 && cartDrawer.classList.contains('active')) {
                cartDrawer.classList.remove('active');
            }
        });
    }

    /**
     * ========================================
     * Specs Table Modal
     * Opens a popup with full table content when 'View full specs' is clicked.
     * Triggered by any .specs-table-trigger button rendered next to a table
     * inside the product_tab2_new (or any collapsible_tab) accordion content.
     * ========================================
     */
    // function initSpecsTableModal() {
    //     var modal = document.getElementById('specs-table-modal');
    //     if (!modal) return;

    //     var modalBody = document.getElementById('specs-table-modal-body');

    //     /**
    //      * Opens the modal and copies content from the source accordion block.
    //      * @param {string} sourceBlockId - id of the accordion__content element
    //      */
    //     function openSpecsModal(sourceBlockId) {
    //         var sourceEl = document.getElementById(sourceBlockId);
    //         if (!sourceEl || !modalBody) return;

    //         // Copy only the inner HTML of the accordion content div.
    //         // We deliberately do NOT clone the wrapper element itself because
    //         // it carries .accordion__content CSS (max-height: 1000px, overflow: hidden)
    //         // which would clip the table rows inside the modal.
    //         var innerHtml = sourceEl.innerHTML;

    //         // Strip out any "View full specs" trigger buttons from the copied markup
    //         var temp = document.createElement('div');
    //         temp.innerHTML = innerHtml;
    //         temp.querySelectorAll('.specs-table-trigger').forEach(function (t) {
    //             t.parentNode.removeChild(t);
    //         });

    //         modalBody.innerHTML = temp.innerHTML;

    //         // Open using native <dialog> API if available, else fallback
    //         if (typeof modal.showModal === 'function') {
    //             modal.showModal();
    //         } else {
    //             modal.setAttribute('open', '');
    //         }

    //         // Lock body scroll
    //         document.body.style.overflow = 'hidden';

    //         // Focus the close button for accessibility
    //         var closeBtn = modal.querySelector('.specs-table-modal__close');
    //         if (closeBtn) { closeBtn.focus(); }
    //     }

    //     function closeSpecsModal() {
    //         if (typeof modal.close === 'function') {
    //             modal.close();
    //         } else {
    //             modal.removeAttribute('open');
    //         }
    //         document.body.style.overflow = '';
    //     }

    //     // Delegate click on all current and future trigger buttons
    //     document.addEventListener('click', function (event) {
    //         var trigger = event.target.closest('.specs-table-trigger');
    //         if (trigger) {
    //             event.preventDefault();
    //             var sourceBlockId = trigger.getAttribute('data-specs-block-id');
    //             openSpecsModal(sourceBlockId);
    //             return;
    //         }

    //         // Close when clicking the overlay or close button
    //         if (event.target.closest('[data-specs-modal-close]')) {
    //             closeSpecsModal();
    //         }
    //     });

    //     // Close on Escape key
    //     document.addEventListener('keydown', function (event) {
    //         if ((event.key === 'Escape' || event.key === 'Esc') && (modal.open || modal.hasAttribute('open'))) {
    //             closeSpecsModal();
    //         }
    //     });

    //     // Native <dialog> cancel event (Esc in Chrome/Firefox)
    //     modal.addEventListener('cancel', function (event) {
    //         event.preventDefault();
    //         closeSpecsModal();
    //     });
    // }

    function initSpecsTableModal() {
        var modal = document.getElementById('specs-table-modal');
        if (!modal) return;

        var modalBody = document.getElementById('specs-table-modal-body');

        // Product-specific image overrides.
        // For listed product handles, the modal will display these images
        // (stacked) instead of cloning the source accordion table markup,
        // regardless of which trigger button was clicked.
        var IMAGE_OVERRIDES = {
            'low-flare-kitchen-sink-gravel-handlebar-system': [
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/593b5252-c811-46f8-9d47-4eb239a9d84c.png?v=1777473329',
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/Kitchen_Sink_Handlebar_Specs.png?v=1777472777',
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/Grips_specs.png?v=1777472786',
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/d2c4fe95-02e8-4492-872a-f4dfe9436b99.png?v=1777472842'
            ]
        };

        function getCurrentProductHandle() {
            var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
            return match ? match[1] : '';
        }

        function getOverrideImages() {
            var handle = getCurrentProductHandle();
            var overrides = IMAGE_OVERRIDES[handle];
            return (overrides && overrides.length) ? overrides : null;
        }

        /**
         * Opens the modal and copies content from the source accordion block,
         * unless an image override is configured for this product.
         * @param {string} sourceBlockId - id of the accordion__content element
         */
        function openSpecsModal(sourceBlockId) {
            if (!modalBody) return;

            var imageUrls = getOverrideImages();

            if (imageUrls && imageUrls.length) {
                var imgHtml = imageUrls.map(function (url) {
                    return '<img src="' + url + '" alt="Specifications" ' +
                           'style="display:block;max-width:100%;height:auto;margin:16px auto;" />';
                }).join('');
                modalBody.innerHTML = '<div class="specs-table-modal__image-wrap">' + imgHtml + '</div>';
            } else {
                var sourceEl = document.getElementById(sourceBlockId);
                if (!sourceEl) return;

                // Copy only the inner HTML of the accordion content div.
                // We deliberately do NOT clone the wrapper element itself because
                // it carries .accordion__content CSS (max-height: 1000px, overflow: hidden)
                // which would clip the table rows inside the modal.
                var innerHtml = sourceEl.innerHTML;

                // Strip out any "View full specs" trigger buttons from the copied markup
                var temp = document.createElement('div');
                temp.innerHTML = innerHtml;
                temp.querySelectorAll('.specs-table-trigger').forEach(function (t) {
                    t.parentNode.removeChild(t);
                });

                modalBody.innerHTML = temp.innerHTML;
            }

            // Open using native <dialog> API if available, else fallback
            if (typeof modal.showModal === 'function') {
                modal.showModal();
            } else {
                modal.setAttribute('open', '');
            }

            // Lock body scroll
            document.body.style.overflow = 'hidden';

            // Focus the close button for accessibility
            var closeBtn = modal.querySelector('.specs-table-modal__close');
            if (closeBtn) { closeBtn.focus(); }
        }

        function closeSpecsModal() {
            if (typeof modal.close === 'function') {
                modal.close();
            } else {
                modal.removeAttribute('open');
            }
            document.body.style.overflow = '';
        }

        // Delegate click on all current and future trigger buttons
        document.addEventListener('click', function (event) {
            var trigger = event.target.closest('.specs-table-trigger');
            if (trigger) {
                event.preventDefault();
                var sourceBlockId = trigger.getAttribute('data-specs-block-id');
                openSpecsModal(sourceBlockId);
                return;
            }

            // Close when clicking the overlay or close button
            if (event.target.closest('[data-specs-modal-close]')) {
                closeSpecsModal();
            }
        });

        // Close on Escape key
        document.addEventListener('keydown', function (event) {
            if ((event.key === 'Escape' || event.key === 'Esc') && (modal.open || modal.hasAttribute('open'))) {
                closeSpecsModal();
            }
        });

        // Native <dialog> cancel event (Esc in Chrome/Firefox)
        modal.addEventListener('cancel', function (event) {
            event.preventDefault();
            closeSpecsModal();
        });
    }

    /**
     * ========================================
     * Per-item Spec Zoom (product-specific override)
     * For listed product handles only:
     *   - hides the combined "View full specs →" trigger button
     *   - replaces the spec accordion content with the configured
     *     IMAGE_OVERRIDES list (one image per spec asset, including
     *     a pre-rendered image of the spec table) and gives each a
     *     zoom icon that opens that single image in the existing
     *     #specs-table-modal.
     * Other products keep the original combined-modal behaviour.
     * ========================================
     */
    function initPerItemSpecZoom() {
        var IMAGE_OVERRIDES = {
            'low-flare-kitchen-sink-gravel-handlebar-system': [
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/593b5252-c811-46f8-9d47-4eb239a9d84c.png?v=1777473329',
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/Kitchen_Sink_Handlebar_Specs.png?v=1777472777',
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/Grips_specs.png?v=1777472786',
                'https://cdn.shopify.com/s/files/1/0089/1220/7951/files/d2c4fe95-02e8-4492-872a-f4dfe9436b99.png?v=1777472842'
            ]
        };

        function getCurrentProductHandle() {
            var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
            return match ? match[1] : '';
        }

        var images = IMAGE_OVERRIDES[getCurrentProductHandle()];
        if (!images || !images.length) return;

        var modal = document.getElementById('specs-table-modal');
        var modalBody = document.getElementById('specs-table-modal-body');
        if (!modal || !modalBody) return;

        var triggers = document.querySelectorAll('.specs-table-trigger');
        if (!triggers.length) return;

        triggers.forEach(function (trigger) {
            var sourceBlockId = trigger.getAttribute('data-specs-block-id');
            var sourceEl = sourceBlockId ? document.getElementById(sourceBlockId) : null;

            // Hide the combined "View full specs" button for this product
            trigger.style.display = 'none';

            if (!sourceEl || sourceEl.dataset.perItemZoomInit) return;
            sourceEl.dataset.perItemZoomInit = '1';

            // Replace accordion content with individually-zoomable images
            sourceEl.innerHTML = '';
            images.forEach(function (url) {
                sourceEl.appendChild(buildZoomItem(url));
            });
        });

        function buildZoomItem(url) {
            var wrap = document.createElement('div');
            wrap.className = 'spec-zoom-wrap';
            wrap.style.cssText = 'position:relative;display:block;margin:1.6rem 0;cursor:zoom-in;';

            var img = document.createElement('img');
            img.src = url;
            img.alt = 'Specifications';
            img.loading = 'lazy';
            img.style.cssText = 'display:block;max-width:100%;height:auto;margin:0 auto;';
            wrap.appendChild(img);

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'spec-zoom-btn';
            btn.setAttribute('aria-label', 'View larger');
            btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
            btn.style.cssText = 'position:absolute;top:8px;right:8px;width:34px;height:34px;border-radius:50%;border:none;background:rgba(17,17,17,0.78);color:#fff;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;z-index:2;padding:0;box-shadow:0 2px 6px rgba(0,0,0,0.18);';
            wrap.appendChild(btn);

            function open(e) {
                if (e) { e.preventDefault(); e.stopPropagation(); }
                openSingleImage(url);
            }

            btn.addEventListener('click', open);
            wrap.addEventListener('click', function (e) {
                if (e.target === btn || btn.contains(e.target)) return;
                open(e);
            });

            return wrap;
        }

        function openSingleImage(url) {
            modalBody.innerHTML =
                '<div class="specs-table-modal__image-wrap">' +
                '<img src="' + url + '" alt="Specifications" ' +
                'style="display:block;max-width:100%;height:auto;margin:0 auto;" />' +
                '</div>';

            if (typeof modal.showModal === 'function') {
                modal.showModal();
            } else {
                modal.setAttribute('open', '');
            }

            document.body.style.overflow = 'hidden';
            var closeBtn = modal.querySelector('.specs-table-modal__close');
            if (closeBtn) closeBtn.focus();
        }
    }

    /**
     * ========================================
     * Shipping Info Popup on Add to Cart
     * Intercepts cart form submission when a variant-specific shipping
     * message is present, shows a confirmation popup, and only proceeds
     * with the Ajax cart add after the user acknowledges the message.
     * ========================================
     */
    function initShippingInfoPopup() {
        // Check if shipping popup is enabled via window variable
        // Liquid sets this: window.shippingPopupEnabled = true
        if (!window.shippingPopupEnabled) {
            return; // Don't initialize popup if not enabled for this product
        }

        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        // Inject styles
        var style = document.createElement('style');
        style.textContent =
            '#shipping-info-popup{display:none;position:fixed;bottom:0;left:0;right:0;top:0;z-index:99999;align-items:center;justify-content:center;}' +
            '#shipping-info-popup.mobile{flex-direction:column;justify-content:flex-end;padding-bottom:260px;}' +
            '.shipping-popup__overlay{position:absolute;inset:0;background:rgba(0,0,0,0.55);}' +
            '.shipping-popup__box{position:relative;background:#fff;border:10px solid #8297b2;border-radius:12px;padding:32px 28px 28px;max-width:420px;width:90%;text-align:center;box-shadow:0 8px 32px rgba(0,0,0,0.2);}' +
            '#shipping-info-popup.mobile .shipping-popup__box{border-radius:12px;width:85vw;max-width:none;margin:0 auto 24px;}' +
            '.shipping-popup__title{font-size:18px;font-weight:700;margin:0 0 16px;letter-spacing:0.04em;text-transform:uppercase;}' +
            '.shipping-popup__message{font-size:15px;line-height:1.6;margin:0 0 24px;color:#333;}' +
            '.shipping-popup__btn{display:inline-block;padding:14px 48px;background:#8297b2;color:#fff;border:none;border-radius:24px;font-size:16px;font-weight:600;cursor:pointer;letter-spacing:0.06em;transition:background 0.2s;}' +
            '.shipping-popup__btn:hover{background:#6b7fa3;}' +
            '@media (max-width:749px){#shipping-info-popup.mobile{padding-bottom:280px;}}';
        document.head.appendChild(style);

        // Inject modal HTML
        var popup = document.createElement('div');
        popup.id = 'shipping-info-popup';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');
        popup.setAttribute('aria-labelledby', 'shipping-popup-title');
        popup.innerHTML =
            '<div class="shipping-popup__overlay"></div>' +
            '<div class="shipping-popup__box">' +
            '<h2 class="shipping-popup__title" id="shipping-popup-title">Important Shipping Info</h2>' +
            '<p class="shipping-popup__message" id="shipping-popup-message"></p>' +
            '<button type="button" class="shipping-popup__btn" id="shipping-popup-ok">OK</button>' +
            '</div>';
        document.body.appendChild(popup);

        // Detect if mobile and add class for bottom-sticky positioning
        function updateMobileClass() {
            if (window.innerWidth < 750) {
                popup.classList.add('mobile');
            } else {
                popup.classList.remove('mobile');
            }
        }
        updateMobileClass();
        window.addEventListener('resize', updateMobileClass);

        var messageEl = document.getElementById('shipping-popup-message');
        var okBtn = document.getElementById('shipping-popup-ok');
        var pendingForm = null;
        var skipPopup = false;

        function openPopup(message, form) {
            pendingForm = form;
            messageEl.textContent = message;
            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            okBtn.focus();
        }

        function closePopup() {
            popup.style.display = 'none';
            document.body.style.overflow = '';
        }

        okBtn.addEventListener('click', function () {
            closePopup();
            if (pendingForm) {
                // Set flag so our capture listener lets this submission pass through
                skipPopup = true;
                pendingForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                pendingForm = null;
            }
        });

        // Capture-phase listener fires before ProductForm's bubble-phase onSubmitHandler.
        // stopImmediatePropagation prevents the event reaching the form entirely while
        // the popup is open; re-dispatching after OK (with skipPopup=true) lets it
        // proceed normally through ProductForm's Ajax cart logic.
        document.addEventListener('submit', function (event) {
            var form = event.target;
            if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

            if (skipPopup) {
                skipPopup = false;
                return;
            }

            // Search for the active shipping message: scoped to product container first,
            // then fall back to document-wide so it works across different template layouts.
            var shippingInput = null;
            var searchRoots = [
                form.closest('product-form'),
                document.querySelector('#product__info_main'),
                document.querySelector('.product__info-wrapper'),
                document.querySelector('.product-info'),
                document
            ];

            for (var i = 0; i < searchRoots.length; i++) {
                if (!searchRoots[i]) continue;
                shippingInput = searchRoots[i].querySelector(
                    '.variant-shipping-message.active input[name="properties[Shipping Info]"]'
                );
                if (shippingInput) break;
            }

            if (!shippingInput) return;

            var message = shippingInput.value.trim();
            if (!message) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            openPopup(message, form);
        }, true /* capture phase */);

        // Allow keyboard dismissal (closes without adding to cart)
        document.addEventListener('keydown', function (event) {
            if ((event.key === 'Escape' || event.key === 'Esc') && popup.style.display !== 'none') {
                closePopup();
                pendingForm = null;
            }
        });
    }

    /**
     * ========================================
     * WOW.js Initialization
     * Initializes the WOW animation library
     * ========================================
     */
    function initWOW() {
        if (typeof WOW !== 'undefined') {
            new WOW().init();
        }
    }

    /**
     * ========================================
     * Initialize All Components
     * Called when DOM is ready
     * ========================================
     */
    function init() {
        // Initialize page reload handling immediately
        initPageReloadHandling();

        // Initialize country detection
        fetchDatacart();

        // Initialize bundle variant selection
        initializeVariantSelection();

        // Initialize click outside handlers
        initMenuDrawerClickOutside();
        initCartDrawerClickOutside();
        initCartDrawerSubtotalHandler();

        // Initialize shipping info popup
        initShippingInfoPopup();

        // Initialize specs table modal
        initSpecsTableModal();

        // Initialize per-item spec zoom (product-specific override)
        initPerItemSpecZoom();

        // Initialize WOW.js
        initWOW();
    }

    // Run initialization
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
